<template>
    <div class="AlbumEdit">
        <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
            <!--<el-form-item label="标题">
                <el-input v-model="formLabelAlign.bt"></el-input>
            </el-form-item>
            <el-form-item label="显示顺序">
                <el-input v-model="formLabelAlign.xssx"></el-input>
            </el-form-item>-->
            <span>上传文件</span>
            <el-form-item class="zwnr">
                <el-upload
                        class="upload-demo"
                        drag
                        ref="uploaddemo"
                        :action="UploadUrl()"
                        :on-success="upSuccess"
                        :on-error="upError"
                        :on-remove="upRemve"
                        :on-change="upChange"
                        enctype="multipart/form-data"
                        :multiple="true"
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                    </div>
                    <div class="el-upload__tip" slot="tip">
                        不能超过10MB
                    </div>
                </el-upload>
                <!--<el-upload
                        style="display:inline-block"
                        :limit="5"
                        drag
                        class="upload-demo"
                        ref="upload"
                        :action="uploadUrl"
                        :file-list="fileList"
                        :http-request="uploadSectionFile"
                        :auto-upload="false"
                        :before-remove="handleRemove">
                    <el-button slot="trigger" size="small" type="primary" plain>选取文件</el-button>
                    <el-button style="margin-left: 10px;" size="small" icon="el-icon-upload2" type="success" @click="submitUpload">导入</el-button>
                </el-upload>-->
            </el-form-item>
            <!--<el-form-item>
                <el-button type="primary" @click="onSubmit">立即创建</el-button>
                <el-button>取消</el-button>
            </el-form-item>-->
        </el-form>
    </div>
</template>

<script>
    import config from "@/config";
    import {mapActions} from "vuex";
    export default {
        name: 'xwedit2',
        data () {
            return {
                fileList: {},
                labelPosition: 'right',
                formLabelAlign: {
                    bt: '',
                    xssx: '',
                },
                cxlx:this.$route.query.cxlx==null?5:this.$route.query.cxlx,
                ruleForm:{
                    nr:''
                },
                content: ''
            }
        },
        methods: {
            ...mapActions([
                'zcxwSave',
            ]),
            UploadUrl:function(){
                return config.baseUrl+'/upload/uploadFile';

            },
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            onSubmit() {
                this.zcxwSave({_module:'TT',_method:'zcxwSave',"bt": this.formLabelAlign.bt,"xssx": this.formLabelAlign.xssx,nr:this.getContent(),wbnr:this.getContentTxt(),cxlx:this.cxlx}).then((res) => {  //这是从本地请求的数据接口，
                    if(res._result.type=="success"){
                        this.$message('保存成功');
                    }else{
                        this.$message(res._result.content);
                    }
                })
            },
            //上传之前
            beforeUpload(file) {
                const fileSuffix = file.name.substring(
                    file.name.lastIndexOf('.') + 1
                );
                const whiteList = ['tar'];
                if (whiteList.indexOf(fileSuffix) === -1) {
                    this.$message({
                        type: 'error',
                        message: '上传文件只能是 tar 格式',
                        showClose: true,
                        offset: 80,
                    });
                    this.fileList = [];
                    return false;
                }
                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isLt2M) {
                    this.$message({
                        type: 'error',
                        message: '上传文件不能超过10MB',
                        showClose: true,
                        offset: 80,
                    });
                    return false;
                }
            },
            // 上传成功
            upSuccess(res) {
                setTimeout(() => {
                    if (res.type == "error") {
                        this.upError();
                        this.upRemve();
                    }else{
                        this.$message({
                            type: 'success',
                            message: '上传成功',
                            showClose: true,
                            offset: 80,
                        })
                    }

                }, 1000);
            },
            // 上传失败
            upError() {
                this.$message({
                    type: 'error',
                    message: '上传失败',
                    showClose: true,
                    offset: 80,
                });
            },
            //上传的文件改变时（覆盖原来的文件）
            upChange(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList = [fileList[fileList.length - 1]];
                }
            },
            // 移除列表
            upRemve() {
                this.$refs.uploaddemo.clearFiles();
            }
        }
    }
</script>

<style>
    .zwnr .el-form-item__content{
        margin-left:0px !important;
        line-height: 0;
    }
</style>